import { render } from "./TheProjectsModalContent.vue?vue&type=template&id=c96f0f46&ts=true"
import script from "./TheProjectsModalContent.vue?vue&type=script&lang=ts"
export * from "./TheProjectsModalContent.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__